const linkFieldValidRegexes = [/^https?:\/\/.*$/, /^mailto:.*$/, /^tel:.*$/, /^\[\[[A-z_]*_url\]\]$/];

export const isValidLink = (linkString: string): boolean =>
    linkString.length > 0 ? linkFieldValidRegexes.some(regex => regex.test(linkString)) : linkString.length === 0;
